import React, { useEffect, useState } from 'react';
import {
  DeleteArImage,
  deleteData,
  getAlert,
  getDataWithComp,
  getDataWithJoin,
  insertData,
  parseCurrency,
  updateData,
  uploadArImage,
} from "../../../utils/SamuiUtils.js";
import Axios from "axios";

const ArImage = ({ isOpen, onClose, arId }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [images, setImages] = useState([]);


  const displayImages = images.length > 0 ? images : [];

  useEffect(() => {
    if (isOpen && arId) {
      fetchImages();
    }
  }, [isOpen, arId]);


  const fetchImages = async () => {
    try {
      if (!arId) {
        console.error("AR ID is required to fetch images.");
        return;
      }

      const response = await getDataWithComp("Tb_Set_ARImage", `AND AR_ID = ${arId}`);


      if (response && Array.isArray(response) && response.length > 0) {

        // แปลงข้อมูลจาก server ให้ตรงกับโครงสร้างที่ใช้ใน component
        const mappedImages = await Promise.all(response.map(async (image, index) => {
          // ดึงชื่อไฟล์จาก URL
          // const getFilenameFromUrl = (url) => {
          //   if (!url) return `รูปหน้าร้าน_${image.img_id}.jpg`;
          //   try {
          //     const urlParts = url.split('/');
          //     return urlParts[urlParts.length - 1] || `รูปหน้าร้าน_${image.img_id}.jpg`;
          //   } catch (error) {
          //     return `รูปหน้าร้าน_${image.img_id}.jpg`;
          //   }
          // };

          // ดึงชื่อร้านจาก DB

          const arName = await getDataWithComp("Tb_Set_AR", `AND AR_ID = (${arId})`);
          return {
            id: image.img_id,
            url: image.file_url,
            filename: arName[0] ? `${arName[0].AR_Name}` : `รูปหน้าร้าน_${image.img_id}`,
            size: "Unknown",
            uploaded: true,
            comp_id: image.comp_id,
            ar_id: image.ar_id,
            is_delete: image.is_delete,
            created_date: image.created_date,
            created_by: image.created_by,
            updated_date: image.updated_date,
            updated_by: image.updated_by
          };
        }));

        setImages(mappedImages);
      } else if (response && response.data && Array.isArray(response.data) && response.data.length > 0) {
        console.log("Fetched images from response.data:", response.data);

        const mappedImages = response.data.map(image => {
          const getFilenameFromUrl = (url) => {
            if (!url) return `รูปหน้าร้าน_${image.img_id}.jpg`;
            try {
              const urlParts = url.split('/');
              return urlParts[urlParts.length - 1] || `รูปหน้าร้าน_${image.img_id}.jpg`;
            } catch (error) {
              return `รูปหน้าร้าน_${image.img_id}.jpg`;
            }
          };

          return {
            id: image.img_id,
            url: image.file_url,
            filename: getFilenameFromUrl(image.file_url),
            size: "Unknown",
            uploaded: true,
            comp_id: image.comp_id,
            ar_id: image.ar_id,
            is_delete: image.is_delete,
            created_date: image.created_date,
            created_by: image.created_by,
            updated_date: image.updated_date,
            updated_by: image.updated_by
          };
        });

        setImages(mappedImages);
      } else {
        console.warn("No images found for the given AR ID.");
        setImages([]);
      }

    } catch (error) {
      console.error("Error fetching images:", error);
      getAlert("FAILED", "ไม่สามารถดึงข้อมูลรูปภาพได้", "กรุณาลองใหม่อีกครั้ง");
      setImages([]);
    }
  }

  const handleImageSelect = (image) => {
    setSelectedImage(image);
  };

  const handleDownload = (imageUrl, filename) => {
    if (imageUrl.startsWith('data:')) {
      // สำหรับ base64
      const link = document.createElement('a');
      link.href = imageUrl;
      link.download = filename || 'image.jpg';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      // สำหรับ URL ปกติ
      const link = document.createElement('a');
      link.href = imageUrl;
      link.download = filename || 'image.jpg';
      link.target = '_blank';
      link.click();
    }
  };

  const handleDeleteImage = (index) => {
    setDeleteIndex(index);
    setShowDeleteConfirm(true);
  };

  const handleConfirmDelete = async () => {
    try {
      const imageToDelete = displayImages[deleteIndex];

      if (imageToDelete && imageToDelete.id && imageToDelete.uploaded) {
        await DeleteArImage(imageToDelete.url);
      }

      // ลบรูปภาพจาก state
      setImages(prevImages => prevImages.filter((_, index) => index !== deleteIndex));

      getAlert("OK", "ลบรูปภาพสำเร็จ", "รูปภาพถูกลบเรียบร้อยแล้ว");

    } catch (error) {
      console.error("Error deleting image:", error);
      getAlert("FAILED", "ไม่สามารถลบรูปภาพได้", "กรุณาลองใหม่อีกครั้ง");
    } finally {
      setShowDeleteConfirm(false);
      setDeleteIndex(null);
    }
  };

  // ฟังก์ชันแปลงไฟล์เป็น base64
  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  };

  const handleAddImage = () => {
    // สร้าง input element เพื่อเลือกไฟล์
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/png,image/jpeg,image/jpg'; // รองรับเฉพาะ PNG และ JPEG
    input.multiple = true;

    input.onchange = async (e) => {
      const files = Array.from(e.target.files);

      if (files.length === 0) {
        getAlert("WARNING", "ไม่พบไฟล์ที่เลือก", "กรุณาเลือกไฟล์รูปภาพ");
        return;
      }

      // ตรวจสอบประเภทไฟล์
      const validImageTypes = ['image/png', 'image/jpeg', 'image/jpg'];
      const invalidFiles = files.filter(file => !validImageTypes.includes(file.type));

      if (invalidFiles.length > 0) {
        const invalidFileNames = invalidFiles.map(file => file.name).join(', ');
        getAlert("WARNING", "ประเภทไฟล์ไม่ถูกต้อง", `ไฟล์ที่ไม่รองรับ: ${invalidFileNames}\nกรุณาเลือกเฉพาะไฟล์ PNG หรือ JPEG เท่านั้น`);
        return;
      }

      const maxFileSize = 10 * 1024 * 1024; // 10MB
      const oversizedFiles = files.filter(file => file.size > maxFileSize);

      if (oversizedFiles.length > 0) {
        const oversizedFileNames = oversizedFiles.map(file => file.name).join(', ');
        getAlert("WARNING", "ไฟล์ใหญ่เกินไป", `ไฟล์ที่ใหญ่เกิน 10MB: ${oversizedFileNames}\nกรุณาเลือกไฟล์ที่มีขนาดไม่เกิน 10MB`);
        return;
      }

      try {
        const base64Promises = files.map(async (file) => {
          const base64 = await convertToBase64(file);

          // ตรวจสอบว่าเป็น base64 ของรูปภาพจริงๆ
          if (!base64.startsWith('data:image/')) {
            throw new Error(`ไฟล์ ${file.name} ไม่ใช่รูปภาพที่ถูกต้อง`);
          }

          return {
            id: Date.now() + Math.random(), // สร้าง ID ชั่วคราว
            url: base64, // ใช้ base64 แทน URL
            filename: file.name,
            size: `${(file.size / 1024).toFixed(2)} KB`,
            base64: base64, // เก็บ base64 ไว้ใช้งาน
            originalFile: file, // เก็บไฟล์ต้นฉบับไว้
            type: file.type // เก็บประเภทไฟล์
          };
        });

        const newImages = await Promise.all(base64Promises);

        // อัปเดต state ด้วยรูปภาพใหม่ (แสดงทันทีก่อนอัปโหลด)
        setImages(prevImages => [...prevImages, ...newImages]);

        // อัปโหลดไฟล์หลายๆ ไฟล์พร้อมกันไปยัง server
        try {
          const base64Array = newImages.map(image => image.base64);
          const uploadResponse = await uploadArImage(base64Array, arId);

          // Refresh ข้อมูลจาก server หลังอัปโหลดสำเร็จ
          // Backend returns { status: "OK" } on success — accept that.
          const ok =
            uploadResponse &&
            (uploadResponse.status === "OK" ||
              uploadResponse.status === "SUCCESS" ||
              uploadResponse.success === true);

          if (ok) {
            setTimeout(() => {
              fetchImages();
            }, 500);
          } else {
            console.error("Unexpected upload response:", uploadResponse);
            throw new Error(uploadResponse?.message || "Upload response indicates failure");
          }

        } catch (uploadError) {
          console.error("Error uploading images:", uploadError);
          getAlert("FAILED", "ไม่สามารถอัพโหลดรูปภาพได้", "กรุณาลองใหม่อีกครั้ง");

          // ลบรูปที่อัปโหลดไม่สำเร็จออกจาก state
          setImages(prevImages => prevImages.filter(img => img.uploaded === true));
        }

      } catch (error) {
        console.error("Error converting images to base64:", error);
        getAlert("FAILED", "ไม่สามารถแปลงรูปภาพได้", error.message || "กรุณาลองใหม่อีกครั้ง");
      }
    };

    input.click();
  };

  return (
    <div
      className={`modal ${isOpen ? "show" : ""}`}
      style={{ display: isOpen ? "block" : "none" }}
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog modal-xl" role="document">
        <div className="modal-content">
          <div className="modal-header d-flex justify-content-between align-items-center">
            <h5 className="modal-title">
              <i className="fa fa-camera me-2"></i>
              รูปถ่ายหน้าร้าน
            </h5>
            <button
              type="button"
              className="close"
              onClick={onClose}
              style={{
                background: "none",
                border: "none",
                fontSize: "24px",
                cursor: "pointer",
              }}
            >
              <span>&times;</span>
            </button>
          </div>

          {/* รูปถ่ายหน้าร้าน */}
          <div className="modal-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="text-start mb-0" style={{ color: "#666", fontWeight: "600" }}>
                {/* <i className="fa fa-camera me-2"></i>
                รูปถ่ายหน้าร้าน */}
              </h6>
              <button
                className="btn text-white"
                style={{
                  backgroundColor: "rgb(239, 108, 0)",
                  whiteSpace: "nowrap",
                  padding: "8px 16px",
                  fontSize: "12px",
                  borderRadius: "6px",
                  border: "none",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
                onClick={handleAddImage}
              >
                <i className="fa fa-plus"></i>
                เพิ่มรูป
              </button>
            </div>
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {displayImages && displayImages.length > 0 ? (
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
                    gap: "20px",
                    justifyContent: "start",
                    padding: "10px",
                  }}
                >
                  {displayImages.map((image, index) => (
                    <div
                      key={index}
                      style={{
                        border: "1px solid #ddd",
                        borderRadius: "12px",
                        padding: "15px",
                        textAlign: "center",
                        backgroundColor: "#fff",
                        position: "relative",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        minHeight: "180px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-4px)";
                        e.currentTarget.style.boxShadow = "0 8px 16px rgba(0,0,0,0.15)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
                      }}
                    >
                      {/* Delete button */}
                      <button
                        style={{
                          position: "absolute",
                          top: "8px",
                          right: "8px",
                          background: "#dc3545",
                          border: "none",
                          borderRadius: "50%",
                          width: "24px",
                          height: "24px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          zIndex: 2,
                          opacity: 0.9,
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteImage(index);
                        }}
                        title="ลบรูป"
                        onMouseEnter={(e) => (e.target.style.opacity = "1")}
                        onMouseLeave={(e) => (e.target.style.opacity = "0.9")}
                      >
                        <i
                          className="fa fa-times"
                          style={{ fontSize: "12px", color: "white" }}
                        ></i>
                      </button>
                      {/* Preview area */}
                      <div
                        style={{
                          marginBottom: "12px",
                          height: "80px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "8px",
                          backgroundColor: "#f8f9fa",
                          overflow: "hidden",
                        }}
                        onClick={() => handleImageSelect(image)}
                      >
                        <img
                          src={image.url}
                          alt={image.filename}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "6px",
                            border: "1px solid #eee",
                            transition: "transform 0.2s ease",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.transform = "scale(1.05)";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.transform = "scale(1)";
                          }}
                        />
                      </div>

                      {/* File info */}
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                        }}
                      >
                        {/* File name */}
                        <div
                          style={{
                            fontSize: "12px",
                            fontWeight: "600",
                            color: "#333",
                            wordBreak: "break-word",
                            lineHeight: "1.3",
                            marginBottom: "8px",
                            minHeight: "32px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          title={image.filename}
                        >
                          {image.filename && image.filename.length > 18
                            ? image.filename.substring(0, 15) + "..."
                            : image.filename}
                        </div>

                        {/* Action buttons */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "8px",
                          }}
                        >
                          {/* View button */}
                          <button
                            className="btn btn-sm"
                            style={{
                              backgroundColor: "rgb(239, 108, 0)",
                              color: "white",
                              padding: "4px 8px",
                              fontSize: "11px",
                              borderRadius: "6px",
                              border: "none",
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              transition: "all 0.2s ease",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleImageSelect(image);
                            }}
                            title="ดูภาพขนาดเต็ม"
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "rgb(204, 92, 0)";
                              e.target.style.transform = "translateY(-1px)";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "rgb(239, 108, 0)";
                              e.target.style.transform = "translateY(0)";
                            }}
                          >
                            <i className="fa fa-eye"></i>
                            <span>ดู</span>
                          </button>

                          {/* Download button */}
                          <button
                            className="btn btn-sm"
                            style={{
                              backgroundColor: "#28a745",
                              color: "white",
                              padding: "4px 8px",
                              fontSize: "11px",
                              borderRadius: "6px",
                              border: "none",
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              transition: "all 0.2s ease",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDownload(image.url, image.filename);
                            }}
                            title="ดาวน์โหลด"
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#218838";
                              e.target.style.transform = "translateY(-1px)";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "#28a745";
                              e.target.style.transform = "translateY(0)";
                            }}
                          >
                            <i className="fa fa-download"></i>
                            <span>Download</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-4">
                  <i
                    className="fa fa-camera"
                    style={{
                      fontSize: "36px",
                      color: "#ccc",
                      marginBottom: "12px",
                    }}
                  ></i>
                  <p style={{ color: "#999", fontSize: "14px", margin: 0 }}>
                    ไม่มีรูปถ่ายหน้าร้าน
                  </p>
                  <p style={{ color: "#bbb", fontSize: "12px", margin: "8px 0" }}>
                    รองรับไฟล์ PNG และ JPEG เท่านั้น (ขนาดไม่เกิน 10MB)
                  </p>
                  <button
                    className="btn btn-sm mt-2"
                    style={{
                      backgroundColor: "rgb(239, 108, 0)",
                      color: "white",
                      padding: "6px 12px",
                      fontSize: "12px",
                      borderRadius: "6px",
                      border: "none",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      margin: "0 auto",
                    }}
                    onClick={handleAddImage}
                  >
                    <i className="fa fa-plus"></i>
                    เพิ่มรูปแรก
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Image Preview Modal */}
      {selectedImage && (
        <div
          className="modal fade show"
          tabIndex="-1"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.8)",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  <i className="fa fa-eye me-2"></i>
                  รูปภาพหน้าร้าน: {selectedImage.filename}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setSelectedImage(null)}
                  aria-label="Close"
                  style={{
                    background: "none",
                    border: "none",
                    fontSize: "24px",
                    cursor: "pointer",
                  }}
                >
                  <span>&times;</span>
                </button>
              </div>
              <div
                className="modal-body text-center"
                style={{ maxHeight: "80vh", overflowY: "auto" }}
              >
                <img
                  src={selectedImage.url}
                  alt={selectedImage.filename}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "70vh",
                    objectFit: "contain",
                    border: "1px solid #ddd",
                  }}
                  className="img-fluid"
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setSelectedImage(null)}
                >
                  <i className="fa fa-times me-2"></i>
                  ปิด
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal ยืนยันการลบรูป */}
      {showDeleteConfirm && (
        <div
          className="modal fade show"
          tabIndex="-1"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1070,
          }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title fw-bold">
                  <i className="fa fa-exclamation-triangle me-2 text-warning"></i>
                  ยืนยันการลบรูป
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setDeleteIndex(null);
                    setShowDeleteConfirm(false);
                  }}
                  aria-label="Close"
                  style={{
                    background: "none",
                    border: "none",
                    fontSize: "24px",
                    cursor: "pointer",
                  }}
                >
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body text-center">
                <i
                  className="fa fa-trash-o"
                  style={{
                    fontSize: "48px",
                    color: "#dc3545",
                    marginBottom: "16px",
                  }}
                ></i>
                <p style={{ fontSize: "16px", marginBottom: "8px" }}>
                  คุณแน่ใจหรือไม่ที่จะลบรูปนี้?
                </p>
                <p style={{ fontSize: "14px", color: "#666" }}>
                  เมื่อลบแล้วจะไม่สามารถกู้คืนได้อีก
                </p>
              </div>
              <div className="modal-footer justify-content-center">
                <button
                  type="button"
                  className="btn btn-lg shadow text-white d-flex align-items-center justify-content-center"
                  style={{
                    backgroundColor: "#dc3545",
                    fontSize: "16px",
                    padding: "12px 24px",
                    borderRadius: "8px",
                    border: "none",
                    minWidth: "120px",
                    gap: "8px",
                  }}
                  onClick={handleConfirmDelete}
                >
                  <i className="fa fa-trash"></i>
                  ลบ
                </button>
                <button
                  type="button"
                  className="btn btn-lg shadow text-white"
                  style={{
                    backgroundColor: "#6c757d",
                    fontSize: "16px",
                    padding: "12px 24px",
                    borderRadius: "8px",
                    border: "none",
                    minWidth: "120px",
                    gap: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={() => {
                    setDeleteIndex(null);
                    setShowDeleteConfirm(false);
                  }}
                >
                  <i className="fa fa-times"></i>
                  ยกเลิก
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ArImage;
